class CacheService {
    static getPageCache( url) {
        const cache = window.__CACHE__;
        if(!cache )  return null;
        if(cache.data){
            const requestCache = cache.data[url];
            delete cache.data[url];
            return requestCache;
        }

        return null;
    }   
}

export default CacheService;